














import Vue from 'vue';
import { mapActions } from 'vuex';
import { IShow } from '../../../../shared/types';
import api from '../../api';

import ShowList from '../../components/ui/show-list/show-list.vue';

export default Vue.extend({
  name: 'Search',

  components: {
    ShowList,
  },

  data: () => ({
    movies: [] as IShow[],

    tvShows: [] as IShow[],
  }),

  async created() {
    this.handlePageLoad({
      name: this.$route.name,
    });
    this.requiresLogin();

    const {
      query,
    } = this.$route.params;

    this.movies = await api.show.searchMovies(query, 1);
    this.tvShows = await api.show.searchTvShows(query, 1);
  },

  methods: {
    ...mapActions('navigation', [
      'handlePageLoad',
      'requiresLogin',
    ]),
  },
});
